import { Component } from '@angular/core';

@Component({
  selector: 'app-factory-summary',
  templateUrl: './factory-summary.component.html',
  styleUrl: './factory-summary.component.scss',
  standalone: false,
})
export class FactorySummaryComponent {}
